import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GraduationCap, Users, BookOpen, ShieldCheck } from 'lucide-react';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900">
      {/* Header */}
      <div className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center">
              <GraduationCap className="w-10 h-10 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">YASHWANTRAO BHONSALE</h1>
              <p className="text-sm text-gray-600">INSTITUTE OF TECHNOLOGY</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-4">
            Mentoring System
          </h2>
          <p className="text-xl text-blue-200">
            Engineering Sciences & Humanities Department - First Year Engineering
          </p>
        </div>

        {/* Login Cards */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* HOD Login Card */}
          <div 
            onClick={() => navigate('/hod-login')}
            className="bg-white rounded-xl shadow-2xl p-8 cursor-pointer transform hover:scale-105 transition-all duration-300"
          >
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <ShieldCheck className="w-12 h-12 text-blue-700" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">HOD Login</h3>
              <p className="text-gray-600 mb-6">
                Manage faculty duties, approvals, and department dashboards
              </p>
              <button className="w-full bg-blue-700 text-white py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors">
                Login as HOD
              </button>
            </div>
          </div>

          {/* Faculty Login Card */}
          <div 
            onClick={() => navigate('/faculty-login')}
            className="bg-white rounded-xl shadow-2xl p-8 cursor-pointer transform hover:scale-105 transition-all duration-300"
          >
            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Users className="w-12 h-12 text-green-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Faculty Login</h3>
              <p className="text-gray-600 mb-6">
                Open the role tabs assigned by the HOD
              </p>
              <button className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors">
                Login as Faculty
              </button>
            </div>
          </div>

          {/* Student Login Card */}
          <div 
            onClick={() => navigate('/student-login')}
            className="bg-white rounded-xl shadow-2xl p-8 cursor-pointer transform hover:scale-105 transition-all duration-300"
          >
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <BookOpen className="w-12 h-12 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Student Login</h3>
              <p className="text-gray-600 mb-6">
                Access your dashboard with Roll Number, Password, and PIN
              </p>
              <button className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                Login as Student
              </button>
            </div>
          </div>
        </div>

        {/* Footer Info */}
        <div className="mt-16 text-center text-blue-200">
          <p className="text-sm">
            Bhonsale Knowledge City Building No.1, Vazarwadi, Charathe
          </p>
          <p className="text-sm">
            Tal: Sawantwadi, Dist: Sindhudurg 416510
          </p>
          <p className="text-xs mt-4 text-blue-300">
            DTE CODE: 3470 | MSBTE CODE: 1742
          </p>
 <p className="text-xs mt-4 text-blue-300">
            Designed and Developed by Prof B. P. Sharaon, ESH Dept, YBIT, Sawantwadi
          </p>
           <p className="text-xs mt-4 text-blue-300">
            Supported by Prof S. D. Rawool, HOD, ESH Dept, YBIT, Sawantwadi
          </p>
        </div>
      </div>
    </div>
  );
}


export default LandingPage;
